export default {
    props: {
        groupAggregates: {
            type: Array,
            default: undefined,
            kComposite: 'group.aggregates'
        },
        groupDir: {
            type: String,
            default: undefined,
            kComposite: 'group.dir'
        }, 
        groupField: {
            type: String,
            default: undefined,
            kComposite: 'group.field'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Group.js